<template>
  <div>
    <v-layout class="main-page">
      <div class="sidebar-wrapper">
        <div v-if="!isDesktop && !sidebar" class="sidebar-nav-closed">
          <div class="sidebar-nav-img-container">
            <img
              class="sidebar-nav-img"
              src="/assets/sidebar-icons/menu-icon.svg"
              alt="Menu"
              @click="toggleSidebar()"
            />
          </div>
        </div>
        <div v-else-if="!isDesktop && sidebar" class="sidebar-nav-open">
          <div class="sidebar-nav-close-icon-container">
            <img
              class="sidebar-nav-close-icon"
              src="/assets/sidebar-icons/close-icon.svg"
              alt="Close"
              @click="toggleSidebar()"
            />
          </div>
        </div>
        <v-layout else class="sidebar-container">
          <div v-if="sidebar" class="sidebar-holder">
            <sidebar :sidebar-config="sidebarConfig" />
            <div class="sidebar-tickets-container">
              <div class="sidebar-tickets-net-sales-container">
                <div class="sidebar-tickets-text">Net sales today</div>
                <div class="sidebar-tickets-amount">{{ netSalesAmount }} EUR</div>
              </div>
              <div class="sidebar-tickets-sold-container">
                <div class="sidebar-tickets-text">Tickets sold today</div>
                <div class="sidebar-tickets-amount">
                  {{ ticketsSoldCount }}
                </div>
              </div>
            </div>
          </div>
        </v-layout>
      </div>
      <v-flex v-show="isDesktop || (!isDesktop && !sidebar)" class="screens">
        <router-view :user="user" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Sidebar from './../Sidebar.vue'
import { GET_LOGGED_USER } from './../../../../graphql/user.graphql'
import { GET_TODAYS_SOLD_TICKETS_STATS } from './../../../../graphql/purchase.graphql'
import { ticketSellerSidebarConfiguration } from './ticket-seller-sidebar-configuration'
import { exchangeRate } from '../../../../utils'

export default {
  name: 'ticket-seller-sidebar',
  components: { Sidebar },

  data() {
    return {
      sidebarConfig: [],
      user: {},
      exchangeRate: exchangeRate,
      sidebar: window.innerWidth > 800 ? true : false,
      isDesktop: window.innerWidth > 800 ? true : false,
      netSalesAmount: 0,
      ticketsSoldCount: 0,
    }
  },
  apollo: {
    getLoggedUser: {
      query: GET_LOGGED_USER,
      manual: true,

      async result({ data, loading }) {
        if (!loading && data.me) {
          this.user = data.me
          this.sidebarConfig = ticketSellerSidebarConfiguration

          const {
            data: { getTodaysSoldTicketsStats: result },
          } = await this.$apollo.query({
            query: GET_TODAYS_SOLD_TICKETS_STATS,
          })

          this.netSalesAmount = result.todaysRevenue
          this.ticketsSoldCount = result.todaysTicketsSoldCount
        }
      },
    },
  },
  watch: {
    $route() {
      this.sidebar = this.isDesktop
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.sidebar = true
        this.isDesktop = true
      } else {
        if (this.isDesktop === true) {
          this.sidebar = false
        }
        this.isDesktop = false
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },
  },
}
</script>

<style scoped>
.main-page {
  display: grid;
  grid-template-columns: 22rem auto;
}

.sidebar-container {
  position: sticky;
  top: 5rem;
}

.sidebar-wrapper {
  grid-column: 1/2;
}

.sidebar-tickets-container {
  margin-top: 2rem;
  border-radius: 0 1.5rem 1.5rem 0;
  background-color: #f5f5f5;
  padding: 1rem 1.5rem;
}

.sidebar-tickets-net-sales-container {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.sidebar-tickets-text {
  font-family: 'Source Sans Pro', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  line-height: 120%;
  color: #979797;
  margin-bottom: 0.25rem;
}

.sidebar-tickets-amount {
  font-family: 'Raleway', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.screens {
  grid-column: 2/3;
  padding: 0 0 0 1.875rem;
}

@media only screen and (max-width: 800px) {
  .main-page {
    grid-template-columns: 100%;
    padding: 0;
  }

  .sidebar-container {
    margin: 0;
  }

  .sidebar-holder {
    width: 100%;
  }

  .sidebar-wrapper {
    grid-column: 1;
    position: relative;
    margin: 0 -24px;
  }

  .sidebar-nav-closed {
    position: absolute;
    right: 1.5rem;
    z-index: 2;
  }

  .sidebar-nav-img-container {
    padding: 0.875rem 0.625rem;
    display: flex;
    background-color: #f5f5f5;
    border-radius: 50%;
    width: fit-content;
  }

  .sidebar-nav-img {
    width: 1.25rem;
    height: 0.75rem;
  }

  .sidebar-nav-open {
    display: flex;
    justify-content: end;
    padding: 0 1.5rem 0.75rem 1.5rem;
  }

  .sidebar-nav-close-icon-container {
    padding: 0.75rem;
    display: flex;
    background-color: #f5f5f5;
    border-radius: 50%;
  }

  .sidebar-nav-close-icon {
    width: 1rem;
  }

  .sidebar-tickets-container {
    border-radius: 1.5rem;
    margin-top: 1.5rem;
  }

  .screens {
    grid-column: 1;
    width: 100%;
    padding: 0;
  }
}
</style>
